// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"04adbe55","859":"f8200fa8","928":"9f3e6dc8"}[chunkId] + ".chunk.css";
};